"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPaymentInfoCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class AddPaymentInfoCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackAddPaymentInfoEvent(this.input);
    }
}
exports.AddPaymentInfoCommand = AddPaymentInfoCommand;
